module.exports = __webpack_public_path__ + "static/headshot-lauren-pearl-2x.1a504d00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-lauren-pearl-2x.jpg
// module id = 123
// module chunks = 35783957827783 152909308826437